import { Component, OnInit } from '@angular/core';
 // Ajustez le chemin
import { catchError, of } from 'rxjs';
import { ITeamOpenPositions } from '../../../_interfaces/teamOpenPositions';
import { TeamsService } from '../../../services/teams.service';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-open-positions-widget',
  standalone: true,
  imports: [ RouterModule, TranslatePipe ],
  templateUrl: './open-positions-widget.component.html',
  styleUrls: ['./open-positions-widget.component.scss']
})
export class OpenPositionsWidgetComponent implements OnInit {
  openPositionsByTeam: ITeamOpenPositions[] = [];
  isLoading = true;
  error: string | null = null;

  constructor(private teamService: TeamsService) { }

  ngOnInit(): void {
    this.loadOpenPositions();
  }

  loadOpenPositions(): void {
    this.isLoading = true;
    this.error = null;
    this.teamService.getOpenPositionsGroupedByTeam().pipe(
      catchError(err => {
        console.error('Error fetching open positions:', err);
        this.error = 'Failed to load open positions. Please try again later.';
        this.isLoading = false;
        return of([]); // Retourne un observable vide pour que le flux se termine proprement
      })
    ).subscribe(data => {
      this.openPositionsByTeam = data;
      this.isLoading = false;
    });
  }

  // Fonction utilitaire pour savoir si une équipe a des positions ouvertes
  hasOpenPositions(team: ITeamOpenPositions): boolean {
    return team.positions && team.positions.length > 0;
  }
}